import React, {useEffect} from 'react';
import './App.css';
import Header from './component/header/header';
import ResultPage from './page/result-page/result-page';
import {Route, Routes} from 'react-router-dom';
import ModificaAccount from './page/modifica-account/modifica-account';
import Footer from './component/footer/footer';
import Autenticazione from './page/autenticazione/autenticazione';
import MyProfile from './page/my-profile/my-profile';
import EliminaAccount from './component/elimina-account/elimina-account';
import InsertOtp from './component/insert-otp/insert-otp';
import NuovaAutenticazioneLink from './component/nuova-autenticazione-link/nuova-autenticazione-link';
import UtenteNonRiconosciuto from './component/utente-non-riconosciuto/utente-non-riconosciuto';
import {ROUTES} from './constant/constant';
import UserService from './service/user-service';
import GoBackBtn from './component/go-back-btn/go-back-btn';

function App() {

  useEffect(() => {
    if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
      UserService.enableMock();
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path={ROUTES.ROOT} element={<ModificaAccount />} />
        <Route path={ROUTES.HOME} element={<ModificaAccount />} />
        <Route
          path={ROUTES.ANY}
          element={<ResultPage title={{ type: 'warning', label: 'OPS! Risorsa non trovata' }} messages={['Qualcosa è andato storto']} />}
        />
        <Route path={ROUTES.AUTENTICAZIONE} element={<Autenticazione />} />
        <Route
          path={ROUTES.AUT_NON_RICONOSCIUTO}
          element={
            <ResultPage
              title={{ type: 'warning', label: 'Utente non riconosciuto' }}
              messages={['Il tuo numero di cellulare non risulta presente sui nostri sistemi.']}
              components={[UtenteNonRiconosciuto]}
              optionalClass={'center-content'}
            />
          }
        />
        <Route
          path={`${ROUTES.GENERIC_ERROR}/:errorMessage`}
          element={
            <ResultPage
              title={{ type: 'error', label: 'Ops...Si è verificato un errore' }}
              messages={['Torna alla pagina precedente']}
              components={[GoBackBtn]}
              optionalClass={'center-content'}
            />
          }
        />
        <Route
          path={ROUTES.GENERIC_ERROR}
          element={
            <ResultPage
              title={{ type: 'error', label: 'Ops...Si è verificato un errore' }}
              messages={['Torna alla pagina precedente']}
              components={[GoBackBtn]}
              optionalClass={'center-content'}
            />
          }
        />
        <Route
          path={ROUTES.AUT_CODICE_SCADUTO}
          element={<ResultPage title={{ type: 'warning', label: 'Ops..il codice è scaduto' }} components={[NuovaAutenticazioneLink]} optionalClass={'center-content'}/>}
        />
        <Route
          path={ROUTES.AUT_CODICE_INVALIDO}
          element={<ResultPage title={{ type: 'warning', label: 'Ops..il codice non è valido' }} components={[() => InsertOtp({isInvalidOTP: true})]} />}
        />
        <Route path={ROUTES.MY_PROFILE} element={<MyProfile />} />
        <Route
          path={ROUTES.MP_UPDATED}
          element={
            <ResultPage
              title={{ type: 'success', label: 'Account modificato' }}
              messages={['La tua richiesta è stata acquisita.', 'I tuoi dati saranno modificati entro 48 ore.']}
              optionalClass={'center-content'}
            />
          }
        />
        <Route
          path={ROUTES.MP_DELETED}
          element={
            <ResultPage
              title={{ type: 'success', label: 'Account eliminato' }}
              messages={[
                'La tua richiesta è stata acquisita.',
                'Entro 48 ore tutti i tuoi dati saranno cancellati dai nostri sistemi.',
                'Grazie per aver utilizzato il servizio',
              ]}
              optionalClass={'center-content'}
            />
          }
        />
        <Route
          path={ROUTES.MP_DELETE}
          element={
            <ResultPage
              title={{ type: 'success', label: 'Elimina account' }}
              messages={['Vuoi eliminare l\'account per l\'accesso al Wi-Fi e tutti i tuoi dati?']}
              components={[EliminaAccount]}
              optionalClass={'center-content'}
            />
          }
        />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
